// removed by extract-text-webpack-plugin
module.exports = {"personContainer":"_2GyUg3L8K5vrlNIVPAXEHa","housemateIcon":"fTLimHrQCu3WUyEXQEFL1","memberName":"_30t_R_94PZFpqHxvUX7Bb0","points":"_15hiHEB3qqml2_jdhGn9SQ","labelBox":"_3P4-RHuWKPd67RgI_YBdmK","iconBox":"_3joXqf7hq9tkruAZw7nR74","editButton":"_1ogAQ3dkS6iIB5kqJ_ABVv","trashButton":"_1BNBNtMKVzZvDm81MMXuIv","editIcon":"_3wusc_7EvqoDCmkJQEj4aV","trashIcon":"_3pKczyilOB0U4JvHxixyYw","housemateIconContainer":"_2Hc_ua0dnIfWVaI3mJ78rC"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/Member.css
// module id = 376
// module chunks = 0